<template>
  
  <v-container grid-list-xl fluid>
    
    <v-layout row wrap v-if="1==0">
      <v-flex xs6 sm4 md3>
        <v-card color="primary" class="white--text">
          <v-card-text>
            <v-layout row>
              <v-flex shrink>
                <div style="float: left;">
                  <v-icon class="white--text" style="font-size: 5em;">fas fa-dollar-sign fa-fw</v-icon>
                </div>
              </v-flex>
              <v-flex expand class="px-3">
                <h5 class="sans-serif text-xs-center">Total Sales</h5>
                <h3 class="mt-3 sans-serif text-xs-center">1,000,000</h3>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6 sm4 md3>
        <v-card color="primary" class="white--text">
          <v-card-text>
            <v-layout row>
              <v-flex shrink>
                <div style="float: left;">
                  <v-icon class="white--text" style="font-size: 5em;">fas fa-tshirt fa-fw</v-icon>
                </div>
              </v-flex>
              <v-flex expand class="px-3">
                <h5 class="sans-serif text-xs-center">Items Sold</h5>
                <h3 class="mt-3 sans-serif text-xs-center">1,000</h3>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6 sm4 md3>
        <v-card color="primary" class="white--text">
          <v-card-text>
            <v-layout row>
              <v-flex shrink>
                <div style="float: left;">
                  <v-icon class="white--text" style="font-size: 5em;">fas fa-tshirt fa-fw</v-icon>
                </div>
              </v-flex>
              <v-flex expand class="px-3">
                <h5 class="sans-serif text-xs-center">Items Sold</h5>
                <h3 class="mt-3 sans-serif text-xs-center">1,000</h3>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6 sm4 md3>
        <v-card color="primary" class="white--text">
          <v-card-text>
            <v-layout row>
              <v-flex shrink>
                <div style="float: left;">
                  <v-icon class="white--text" style="font-size: 5em;">fas fa-tshirt fa-fw</v-icon>
                </div>
              </v-flex>
              <v-flex expand class="px-3">
                <h5 class="sans-serif text-xs-center">Items Sold</h5>
                <h3 class="mt-3 sans-serif text-xs-center">1,000</h3>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row class="mt-4">
      <v-flex
        class="text-xs-right"
      >
        <v-btn flat @click="$refs.calendar.prev()" color="primary" style="min-width: 0px;">
          <v-icon
            dark
          >
            fas fa-arrow-left
          </v-icon>
        </v-btn>
      </v-flex>
      <v-flex shrink class="text-xs-center">
        <h3 class="sans-serif mt-2">{{ $moment(calendar).format('MMMM YYYY') }}</h3>
      </v-flex>
      <v-flex
        class="text-xs-left"
      >
        <v-btn flat @click="$refs.calendar.next()" color="primary" style="min-width: 0px;">
          <v-icon
            dark
          >
            fas fa-arrow-right
          </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex style="position: relative;">
        <div style="position: absolute; top: -4px; left: 12px; right: 12px;" v-if="loading">
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-0"
            height="2"
          ></v-progress-linear>
        </div>
        <v-sheet height="500">
          <v-calendar
            v-model="calendar"
            ref="calendar"
            color="primary"
            :loading="true"
          >
            <template v-slot:day="{ date }">
              <template v-for="(trip,tripIndex) in tripsMap[date]">
                <v-menu
                  :key="trip.reservation_name + tripIndex"
                  v-model="trip.open"
                  full-width
                  offset-x
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <div
                      v-ripple
                      class="my-event"
                      v-on="on"
                    >
                      <v-tooltip top>
                        <v-icon slot="activator" style="font-size: 1em;" color="white" v-if="!trip.lookbook_id">fas fa-exclamation-triangle fa-fw</v-icon>
                        <span>No Lookbook Configured</span>
                      </v-tooltip>
                      {{ trip.reservation_name }}
                    </div>
                  </template>
                  <v-card
                    color="grey lighten-4"
                    min-width="350px"
                    flat
                  >
                    <v-toolbar
                      color="primary"
                      dark
                    >
                      <v-toolbar-title v-html="trip.reservation_name"></v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="trip.open = false">
                        <v-icon>fas fa-times</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text primary-title>
                      <div v-if="!trip.lookbook_id" class="text-xs-center mb-3 red--text">No Lookbook Created</div>
                      <div class="text-xs-center title">{{ $moment(trip.checkin_date, ['MM/DD/YYYY']).format("L") }} - {{ $moment(trip.checkout_date, ['MM/DD/YYYY']).format("L") }}</div>
                      <div class="text-xs-center mt-3">
                        <v-btn color="primary" :to="{name: 'admin-trip',params:{trip_id:trip._id}}">VIEW</v-btn>
                      </div>
                    </v-card-text>
                    
                  </v-card>
                </v-menu>
              </template>
            </template>
          </v-calendar>
        </v-sheet>
      </v-flex>
    </v-layout>

  </v-container>

</template>

<script>

export default {
  name: 'AdminDashboard',
  data () {
    return {
      loading: true,
      calendar: this.$moment().format("YYYY-MM-DD"),
      trips: [],
      lookbooks: {},
      orders: {}
    }
  },
  mounted: function() {
    this.getDataFromApi();
  },
  watch: {
    calendar: function(newVal, oldVal) {
      this.getDataFromApi();
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    tripsMap () {
      const map = {}
      this.trips.forEach(t => (map[ this.$moment(t.checkin_date, ['MM/DD/YYYY']).format("YYYY-MM-DD") ] = map[ this.$moment(t.checkin_date, ['MM/DD/YYYY']).format("YYYY-MM-DD") ] || []).push(t))
      return map
    }
  },
  methods: {
    getDataFromApi: function() {
      this.loading = true;
      
      let start = this.$moment( this.calendar ).subtract(1, 'month').format("YYYY-MM") + '-20';
      let end = this.$moment( this.calendar ).add(1, 'month').format("YYYY-MM") + '-10';

      this.$http.get('trips?ciAfter=' + start + '&ciBefore=' + end) 
        .then(response => {
          this.trips = response.data.data;
          for(let i = 0; i < this.trips.length; i++) {
            let trip = this.trips[i];
            if(trip.lookbook_id) {
              this.loadLookbook(trip.lookbook_id);
            }
          }
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error loading trip data');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    loadLookbook: function(lookbook_id) {
      let lookbook = this.$store.getters.lookbookFromCache(lookbook_id);
      if(lookbook) {
        this.$set(this.lookbooks, lookbook_id, lookbook);
        if(lookbook.order_id) this.loadOrder(lookbook.order_id);
        return;
      } else {
        this.$http.get('lookbooks/' + lookbook_id)
          .then(response => {
            this.$store.commit('setLookbookCache', response.data);
            this.$set(this.lookbooks, response.data._id, response.data);
            if(response.data.order_id) this.loadOrder(response.data.order_id);
          })
          .catch(error => {
            this.$swal.fire('Error', 'There was an error loading lookbook data');
          })
      }

    },

    loadOrder: function(order_id) {
      let order = this.$store.getters.orderFromCache(order_id);
      if(order) {
        this.$set(this.orders, order_id, order);
        return;
      } else {
        this.$http.get('orders/' + order_id)
          .then(response => {
            this.$store.commit('setOrderCache', response.data);
            this.$set(this.orders, response.data._id, response.data);
          })
          .catch(error => {
            this.$swal.fire('Error', 'There was an error loading order data');
          })
      }

    }

  }
}
</script>

<style lang="scss" scoped>

  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }

</style>
